<template>
    <div>
        <v-row class="text-center">
            <v-col>
                <img src="../assets/cookie.svg" width="70" style="margin-bottom: -75px;"/>
            </v-col>
        </v-row>
        <v-row class="text-center">
            <v-col>
                <img src="../assets/essensplan.svg" style="margin-bottom: -30px;"/>
            </v-col>
        </v-row>
        <v-row class="text-center">
            <v-col class="mb-4">
                <meal-table/>
                <v-dialog v-model="showAddEntryForm"
                          fullscreen
                          transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-row class="text-center">
                            <v-col class="mb-4">
                                <v-btn
                                    class="[ c-btn-fixed  c-btn-fixed--bottom ]  [ mx-2 ]"
                                    fab
                                    dark
                                    color="cyan"
                                    ref="showAddEntryForm"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <v-container class="white">
                        <v-row class="text-center">
                            <v-col>
                                <add-entry-form/>
                            </v-col>
                        </v-row>
                        <v-row class="text-center">
                            <v-col>
                                <v-btn
                                    large
                                    class="grey"
                                    dark
                                    block
                                    @click="showAddEntryForm = false"
                                >
                                    Schließen
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import MealTable from '../components/MealTable'
import Form from '../components/Form'

export default {
    name: 'MealPlan',
    components: {
        mealTable: MealTable,
        addEntryForm: Form
    },
    data() {
        return {
            showAddEntryForm: false,
            secretMessage: '',
            username: '',
        }
    }
}
</script>
